var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "icon-pack-about display-flex flex-column flex-content-between",
      staticStyle: { gap: "var(--spacing-2xl)", height: "100%" },
      attrs: { id: "icon-pack-about" },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "display-flex flex-items-center",
            staticStyle: { gap: "var(--spacing-sm)" },
          },
          [
            _c(
              "h1",
              {
                staticClass: "text-uppercase size-md margin-bottom-0",
                staticStyle: {
                  "letter-spacing": "var(--letter-spacing-3xl)",
                  "font-weight": "var(--font-weight-black)",
                  color: "var(--theme-title-color)",
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.iconPack().name) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                attrs: {
                  "aria-label": _vm.packTagTooltipText,
                  "data-balloon-pos": "up",
                },
              },
              [
                _c("wa-tag", {
                  attrs: {
                    "is-rounded": "",
                    label: _vm.packTagLabel,
                    theme: _vm.packTagTheme,
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "margin-top-sm" }, [
          _vm._v(_vm._s(_vm.iconPack().editorial.title)),
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "line-height": "var(--line-height-lg)" } }, [
          _vm._v(
            "\n      " + _vm._s(_vm.iconPack().editorial.description) + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("pack-actions"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }